<template>
  <div class="pg-index">
    <div class="section1">
      <div class="logo"></div>
      <div class="slogan"></div>
      <div class="sub-title"></div>
    </div>
    <div class="section2">
      <!-- 无id且未登陆或未创建队伍 -->
      <div class="btn create"></div>
    </div>
    <div class="section3">
      <div class="op">
        <div class="op-btn rule" @click="showRule"></div>
        <div class="op-btn content" @click="showPrize"></div>
      </div>
      <a :href="address" class="guanzhu" target="_blank"></a>
    </div>
  </div>
</template>
<script>
import store from '~/store/index';
import * as types from '~/store/mutation-type';
// import Message from '~/components/Message';
import { mapState } from 'vuex';
import {isMobile, isAndroid} from '~/tools/utils';
import imgUrl from './images/share.png';

export default {
  data() {
    return {
      isPc: !isMobile(),
      isAndroid: isAndroid(),
      address: isMobile() ? 'https://zt.ztgame.com/m/news/newsinfo_6218.html' : 'https://zt.ztgame.com/html/news/1346547/00a-1634-0184a-292938.shtml'
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo
    })
  },
  mounted() {
    const _this = this
    store.commit(types.SHOW_LOADING, false);
    if (import.meta.env.VITE_APP_ENV !== 'development') {
      requirejs(["share/share"], function (ztshare) {
        new ztshare({
          url: location.href,
          title: '征途16周年庆，1元秒实物', // 分享标题，如果不设置会获取页面的
          desc: '征途16周年庆典开启，10月21日千件实物1元秒杀！配套绝版礼包免费送！', // 分享描述
          images: imgUrl,
          phone: {
            dataUrl: location.href,
            success: function () {},
            cancel: function () {},
          },
        });
      })
    }
  },
  methods: {
    showPrize() {
      store.commit(types.SHOW_MODAL, {type: 'content'});
    },
    showRule() {
      store.commit(types.SHOW_MODAL, {type: 'rule'});
    }
  }
}
</script>
<style rel="stylesheet/stylus" lang="stylus" scoped>
@import '../../assets/stylus/minixs/_center.styl';
    .pg-index
        margin 0 auto;
        width: 7.5rem;
        height: 100%;
        position: relative;
        .section1
          width: 100%;
          height 10rem
          background-image url('./images/bg1.png')
          background-size 100% 100%
          padding-top 1rem
          position relative
          .logo
            margin-left 2.93rem
            height: 0.94rem
            width 2rem
            background-size 100% 100%
            background-image url('./images/title.png')
          .slogan
            margin-left 0.56rem
            margin-top -0.7rem
            width: 6.73rem
            height 3.13rem
            background-size 100% 100%
            background-image url('./images/slogan.png')
            animation down 0.6s 1 linear;
          .sub-title
            margin-left 1.51rem
            margin-top -0.62rem
            width: 4.5rem
            height 0.47rem
            background-size 100% 100%
            background-image url('./images/sub.png')
            animation up 0.6s 1 linear;
        .section2
          width: 100%;
          height 10.5rem
          background-image url('./images/bg2.png')
          background-size 100% 100%
          padding-top 2.38rem
        .section3
          width: 100%;
          height 14.5rem
          background-image url('./images/bg3.png')
          background-size 100% 100%
          padding-top 8.03rem
          margin-top -1px
          .guanzhu
            display block
            width: 3.6rem;
            height 1.04rem
            background-image url('./images/guanzhu.png')
            background-size 100% 100%
            margin-left 1.95rem
            margin-top 3.85rem
            cursor pointer
          .op
            width: 6.1rem
            height 0.81rem
            margin-left 0.7rem
            display flex
            justify-content space-between
            &-btn
              width: 2.81rem
              height 0.81rem
              background-size 100% 100%
              cursor pointer
              &.rule
                background-image url('./images/rule.png')
              &.content
                background-image url('./images/content.png')
        .rule
          margin-top -1px
          width: 100%;
          height 9.81rem
          background-size 100% 100%
          position relative
        .hide
            display: none

        .show
            display: block !important;

        @keyframes up
            0%
                opacity: 0;
                transform: translateY(100%);
            100%
                opacity: 1;
                transform: translateY(0);

        @keyframes down
            0%
                opacity: 0;
                transform: translateY(-100%);
            100%
                opacity: 1;
                transform: translateY(0);
</style>
